"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var Filter = /** @class */ (function (_super) {
    __extends(Filter, _super);
    function Filter(data) {
        var _this = _super.call(this, data) || this;
        _this.id = data.id;
        _this.collapse = data.collapse;
        _this.variants = data.variants.map(function (v) {
            return {
                label: v.label,
                slug: v.slug,
                value: v.value,
                imageId: v.image_id,
                isFavorite: v.is_favorite,
                depth: v.depth,
                parentId: v.parent_id,
                description: v.description
            };
        });
        _this.name = data.name;
        _this.slug = data.slug;
        _this.min = data.min;
        _this.max = data.max;
        _this.unit = data.unit;
        _this.help = data.help;
        _this.available = data.available;
        _this.default = data.default;
        _this.filterName = data.filterName;
        _this.filterType = data.type;
        _this.filterTemplate = data.filter_template;
        _this.urlSort = data.url_sort;
        _this.nameForFilter = data.name_for_filter;
        _this.nameForProduct = data.name_for_product;
        _this.nameForProductCard = data.name_for_product_card;
        _this.hideNameOnProduct = data.hide_name_on_product;
        _this.hideNameOnProductCard = data.hide_name_on_product_card;
        _this.counts = data.counts;
        return _this;
    }
    return Filter;
}(BaseEntity_1.BaseEntity));
exports.Filter = Filter;
//# sourceMappingURL=Filter.js.map